import ApiService from "../../common/services/ApiService";

const api = new ApiService();

export const getDomainOptions = async () => {
   try {
      const domains = await api.query(`/api/v1/domains/options`);
      return domains;
    } catch (error) {
      console.error(error);
    }
}

export const getDivisionOptions = async () => {
   try {
      const divisions = await api.query(`/api/v1/divisions/options`);
      return divisions;
    } catch (error) {
      console.error(error);
    }
}

export const getVocationalActivitiesOptions = async () => {
   try {
      const vocationalActivities = await api.query(`/api/v1/vocational_activities/options`);
      return vocationalActivities;
    } catch (error) {
      console.error(error);
    }
}

export const getDepartmentOptions = async () => {
   try {
      const departments = await api.query(`/api/v1/departments/options`);
      return departments;
    } catch (error) {
      console.error(error);
    }
}

export const getActivityIntervalOptions = async () => {
   try {
      const activityIntervals = await api.query(`/api/v1/point_requests/activity_intervals`);
      return activityIntervals;
    } catch (error) {
      console.error(error);
    }
}

export const getEmploymentTypeOptions = async () => {
   try {
      const employmentTypes = await api.query(`/api/v1/employment_types/options`);
      return employmentTypes;
    } catch (error) {
      console.error(error);
    }
}
